"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFilterFromPOJOs = exports.isExtensionFromRawFileSupported = exports.getFileExtensionFromRawFile = exports.addSupportInfoToFiles = void 0;

var _immutable = require("immutable");

var _FileExtensionFilters = _interopRequireDefault(require("FileManagerLib/enums/FileExtensionFilters"));

var _i18n = require("FileManagerLib/utils/i18n");

var getIsFileNotSupported = function getIsFileNotSupported(fileExtension, extensions, filterType) {
  if (filterType === _FileExtensionFilters.default.NONE) return false;
  var isFileInExtensions = extensions.has(fileExtension);
  return filterType === _FileExtensionFilters.default.SUPPORTED ? !isFileInExtensions : isFileInExtensions;
};

var getNotSupportedReason = function getNotSupportedReason(extensions, reasons, fileExtension, filterType) {
  return reasons.get(fileExtension) || (0, _i18n.getFileFilteringErrorMessage)(extensions, filterType);
};

var addSupportInfoToFiles = function addSupportInfoToFiles(files, filter) {
  var extensions = filter.get('extensions');
  var reasons = filter.get('reasons');
  var filterType = filter.get('filterType');

  if (extensions.count() && filterType !== _FileExtensionFilters.default.NONE) {
    return files.map(function (file) {
      var fileExtension = file.get('extension');
      var notSupported = getIsFileNotSupported(fileExtension, extensions, filterType);
      return file.merge({
        notSupported: notSupported,
        notSupportedReason: notSupported && getNotSupportedReason(extensions, reasons, fileExtension, filterType)
      });
    });
  }

  return files;
};

exports.addSupportInfoToFiles = addSupportInfoToFiles;

var getFileExtensionFromRawFile = function getFileExtensionFromRawFile(rawFile) {
  return rawFile.name.split('.').pop();
};

exports.getFileExtensionFromRawFile = getFileExtensionFromRawFile;

var isExtensionFromRawFileSupported = function isExtensionFromRawFileSupported(rawFile, filter) {
  return !getIsFileNotSupported(getFileExtensionFromRawFile(rawFile), filter.get('extensions'), filter.get('filterType'));
};

exports.isExtensionFromRawFileSupported = isExtensionFromRawFileSupported;

var buildFilterFromPOJOs = function buildFilterFromPOJOs(filterType, filteredExtensions, filteredReasons) {
  return (0, _immutable.Map)({
    extensions: (0, _immutable.Set)(filteredExtensions),
    reasons: (0, _immutable.Map)(filteredReasons),
    filterType: filterType || _FileExtensionFilters.default.NONE
  });
};

exports.buildFilterFromPOJOs = buildFilterFromPOJOs;